<template>
  <div class="custom-reset">
    <breeze-validation-errors class="mb-4" />

    <form @submit.prevent="submit">
      <div class="form-floating mb-4 text-center">
        <img src="/media/live/logo.png" alt="Corsync" class="logo" />
      </div>
      <div class="form-floating mb-4 text-center">
        <h4>Reset Password</h4>
      </div>
      <div class="form-floating mb-4 text-center">
        <breeze-label for="email" value="Email" v-show="form.email === ''" />
        <breeze-input
          id="email"
          type="email"
          class="form-control"
          v-model="form.email"
          required
          autofocus
          autocomplete="username"
        />
      </div>

      <div class="form-floating mb-4 text-center">
        <breeze-label
          for="password"
          value="Password"
          v-show="form.password === ''"
        />
        <breeze-input
          id="password"
          type="password"
          class="form-control"
          v-model="form.password"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="form-floating mb-4 text-center">
        <breeze-label
          for="password_confirmation"
          value="Confirm Password"
          v-show="form.password_confirmation === ''"
        />
        <breeze-input
          id="password_confirmation"
          type="password"
          class="form-control"
          v-model="form.password_confirmation"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="form-floating mb-4 text-center">
        <breeze-button
          class="btn btn-primary"
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Reset Password
        </breeze-button>
      </div>
    </form>
  </div>
</template>
<script>
import BreezeButton from '@/Components/Elements/Button'
import BreezeInput from '@/Components/Elements/Input'
import BreezeLabel from '@/Components/Elements/Label'
import BreezeValidationErrors from '@/Components/Elements/ValidationErrors'
export default {
  components: {
    BreezeButton,
    BreezeInput,
    BreezeLabel,
    BreezeValidationErrors,
  },
  props: {
    email: String,
    token: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        token: this.token,
        email: this.email,
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post(this.route('password.update'), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.logo {
  height: 64px;
  width: auto;
}
.custom-reset {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>
